import { connect } from 'react-redux';
import CheckoutViewComponent from './checkout_view';
import SuccessView from './success_view';
import CanceledView from './canceled_view';
import * as AccountsSelectors from 'shared_redux/selectors/models/accounts';

const mapStateToProps = (state) => {
    const account = AccountsSelectors.getAccount(state);
    return {
        organizationId: account ? account.organization_id : null
    };
};

const CheckoutView = connect(mapStateToProps)(CheckoutViewComponent);

export { CheckoutView, SuccessView, CanceledView };
